import { render, staticRenderFns } from "./ServiceImmobilier.vue?vue&type=template&id=6899746d&scoped=true&"
import script from "./ServiceImmobilier.vue?vue&type=script&lang=js&"
export * from "./ServiceImmobilier.vue?vue&type=script&lang=js&"
import style0 from "./ServiceImmobilier.vue?vue&type=style&index=0&id=6899746d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6899746d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VImg,VRow})
